import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">DCTabloid · Your Source for News</p>
        <h1>Stay Informed, Stay Ahead.</h1>
        <p className="lede">
          DCTabloid brings you the latest news and insights from around the world. Explore our articles, stay updated, and engage with the stories that matter to you.
        </p>
        <div className="cta-row">
          <a href="/latest-news" target="_self">
            Read the Latest News
          </a>
          <a href="/subscribe" target="_self" className="secondary">
            Subscribe Now
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Get real-time updates on the most important events happening globally. Our team is dedicated to bringing you the news as it unfolds.
          </p>
        </article>
        <article>
          <h2>In-Depth Analysis</h2>
          <p>
            Dive deeper into the stories with our expert analysis and opinion pieces. Understand the context and implications of current events.
          </p>
        </article>
        <article>
          <h2>Community Engagement</h2>
          <p>
            Join the conversation! Share your thoughts and connect with others in our community. Your voice matters in shaping the narrative.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;